<template>
    <div>
        <breadcrumb :routerList="[{to:'/jingpin/detail',title:'竞品管理'},{title:'竞争对手详情'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-pieceIn2">
                    <div class="h-pieceTitle2">
                        <h1>基础信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine h-mrb-38">
                            <el-form 
                                :model="duishou" 
                                ref="formLabelAlign" 
                                :inline="true"
                                class="demo-ruleForm h-formbLine">
                                <el-form-item label="公司名称" class="h-elformWrap-2">
                                    <el-input v-model="duishou.companyName" disabled="disabled"></el-input>
                                </el-form-item>
                                <el-form-item label="是否关注" class="h-elformWrap-2">
                                    <el-input v-model="duishou.concern==0?'否':'是'" disabled="disabled"></el-input>
                                </el-form-item>
                                <el-form-item label="备注信息" class="h-elformWrap-2">
                                    <el-input v-model="duishou.comment" disabled="disabled"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-piece h-mrt30">
                <div class="h-pieceIn2">
                    <div class="h-pieceTitle2">
                        <h1>趋势总览</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formBox">
                            <el-form :inline="true" class="demo-form-inline h-formBorder">
								<div class="h-thirdColumn w-newColumn">
                                <el-form-item label="区域">
                                    <brselect 
                                    category="YLRegion" 
                                    :v="qushi.area" 
                                    v-model="qushi.area"
                                    placeholder="--请选择--"></brselect>
                                </el-form-item>
                                <el-form-item label="产品大类">
                                    <el-select v-model="qushi.category" placeholder="请选择">
                                        <el-option 
                                            v-for="item in bigCategoryOptions" 
                                            :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="创建时间" style="width: 50%;">
									<el-date-picker 
										type="date" 
										:v="qushi.start" 
										value-format="yyyy-MM-dd"
										v-model="qushi.start"
										placeholder="选择时间"
										:clearable="false" 
										></el-date-picker>
										<span class="w-time-to">至</span>
									<el-date-picker 
										type="date" 
										:v="qushi.end" 
										:clearable="false" 
										value-format="yyyy-MM-dd"
										v-model="qushi.end"
										placeholder="选择时间" 
										>
									</el-date-picker>
                                </el-form-item>
                            </div>
							<div class="h-formBtnOut h-columnCenter">
								<el-button class="h-btn h-formBtn" @click="handleFilterInfo">检索</el-button>
								<el-button
								    class="h-btn h-formBtn" 
								    @click="qingKong"
								    style="background-color:white;color:black;border:1px solid #d1d1d1">重置
								</el-button>
							</div>
                            </el-form>
                        </div>
                        <div class="h-borderPiece h-mrt40">
                            <div class="h-borderPiecein">
                                <div class="h-borderPieceinner">
                                    <div class="h-bPieceTitle">
                                        <h1>2019年{{duishou.companyName}}产品销售区域分布统计</h1>
                                    </div>
                                    <div style="position: relative;">
                                        <div class="h-chart" id="h_mapChart" style="width: 100%; height: 3.8rem;">
                                        </div>
                                        <div class="h-mapInfo">
                                            <p class="h-mapInfoNum">全国共<span>{{fenBuNum}}</span>个销售点</p>
                                            <span class="h-mapInfoIcon">
												<i></i>
												<span>销售分布点</span>
											</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="h-borderPiecein">
                                <div class="h-borderPieceinner">
                                    <div class="h-bPieceTitle">
                                        <h1>2019年{{duishou.companyName}}产品销售增长对比</h1>
                                    </div>
                                    <div class="h-chart" id="h_lineChart" style="width: 100%; height: 3.8rem;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="h-borderPiece h-mrt30">
                            <div class="h-borderPiecein" style="width: 100%;">
                                <div class="h-borderPieceinner">
                                    <div class="h-bPieceTitle">
                                        <h1>2019年{{duishou.companyName}}产品竞争态势</h1>
                                    </div>
                                    <div class="h-hidden">
                                        <div 
                                            class="h-chart h-fl" 
                                            id="h_barChart"
                                            style="width: 80%; height: 3.45rem;">
                                        </div>
										<div class="h-chart h-fl" style="width: 20%; height: 3.45rem;">
											<div class="h-disTable">
												<div class="h-tableCell">
													<div class="h-progress">
														<div class="h-progressItem">
															<div class="h-progressItemT">
																<h1>海尔产品</h1>
																<span>+16.1%</span>
															</div>
															<div class="h-progressItemB">
																<span style="width: 70%;"></span>
															</div>
														</div>
														<div class="h-progressItem">
															<div class="h-progressItemT">
																<h1>{{duishou.companyName}}</h1>
															</div>
															<div class="h-progressItemB h-progressGreen">
																<span style="width: 70%;"></span>
															</div>
														</div>
													</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-piece h-mrt30">
                <div class="h-pieceIn2">
                    <div class="h-pieceTitle2">
                        <h1>数据报表</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formBox">
                            <el-form :inline="true" class="demo-form-inline h-formBorder">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="客户名称">
									    <el-select v-model="cusmname" placeholder="请选择">
									        <el-option 
									        v-for="item in cusmnameOptions" 
									        :key="item.value" :label="item.label"
									        :value="item.value">
									        </el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="产品大类">
									    <el-select v-model="bigCategory" placeholder="请选择">
									        <el-option 
									            v-for="item in bigCategoryOptions" 
									            :key="item.value" :label="item.label"
									            :value="item.value">
									        </el-option>
									    </el-select>
									</el-form-item>
									<el-form-item label="　　出厂截止日期">
										<el-date-picker 
											style="width: 100%"
											type="date" 
											value-format="yyyy-MM-dd" 
											v-model="timechange"
											:clearable="false"
											placeholder="选择时间">
										</el-date-picker>
									</el-form-item>
									<el-form-item class="right-item">
										<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
										<el-button class="h-btn h-formBtn h-bgwhite" @click="qingKong">重置</el-button>
									</el-form-item>
								</div>
                            </el-form>
                        </div>
                        <div class="h-table h-mrt30">
                            <el-table
                                ref="multipleTable"
                                @selection-change="handleSelectionChange"
                                :data="shujuTableData"
                                stripe
                                style="width: 100%"
								:border="true"
								max-height="500"
                                >
                                <el-table-column
                                    fixed
                                    type="index"
                                    label="#"
                                    width="40">
                                </el-table-column>
                                <el-table-column
                                    prop="userName"
                                    label="客户名称"
                                    :show-overflow-tooltip="true"
                                    min-width="250">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.userName}}
										</div>
									</template>
                                </el-table-column>
                                <el-table-column
                                    prop="channel"
                                    label="销售渠道"
                                    width="170">
                                    <template slot-scope="scope">
                                        {{scope.row.channel|dictname('sales_region')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="area"
                                    label="销售区域"
                                    width="170">
                                    <template slot-scope="scope">
                                        <dictname category="YLRegion"  :v="scope.row.area"/>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="specification"
                                    label="产品型号"
                                    width="170">
                                </el-table-column>
                                <el-table-column
                                    prop="barCode"
                                    label="条形码"
                                    width="165">
                                </el-table-column>
                                <el-table-column
                                    prop="exfactoryDate"
                                    sortable
                                    label="生产日期"
                                    :show-overflow-tooltip="true"
                                    width="165">
                                </el-table-column>
                            </el-table>
                            <div class="h-tableB h-mrt30">
                                <div class="h-tableBL">
                                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                               @click="outExcel">批量导出
                                    </el-button>
                                </div>
                                <div class="h-pagination2">
                                    <pagination :page="q" @query="query"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    require('echarts/map/js/china.js')
    export default {
        data() {
            return {
                //检索标志
                jianSuo: false,
                //翻页入参
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                qushi:{//趋势查询对象
                    start: '',//趋势总览开始时间
                    end: '',//趋势总览结束时间
                    category: '', //大类选中值
                    area:'',//区域
                },
                fenBuNum:'',//分布数量
                timechange: '',//选择时间
                // basicmes: {},//标题栏
                // chanpin: [], //产品集合对象
                // yonghu: {},//产品信息id:唯一用户信息对象
                // dalei: {},//产品信息id:大类对象
                vw: [],//视图集合
                duishou: {}, //对手
                cusmname: '',//客户名选中值
                cusmnameOptions: [],
                area: '',//区域选中值
                bigCategory: '', //大类选中值
                bigCategoryOptions: [],
                // leltype: '是否关注',//等级选中值
                // lelOptions: [{
                //     value: '1',
                //     label: '高'
                // }, {
                //     value: '2',
                //     label: '中'
                // }, {
                //     value: '3',
                //     label: '低'
                // }, {
                //     value: '0',
                //     label: '取消关注'
                // }],
                // idmsg: '',
                // comp: {},
                // //表单
                // formLabelAlign: {
                //     formCon1: '',
                //     formCon2: '',
                //     formCon3: '',
                //     formCon4: '',
                //     formCon5: '',
                //     formCon6: '',
                //     formCon7: '',
                //     formCon8: '',
                //     formCon9: '',
                //     formCon10: '',
                //     formCon11: '',
                // },
                //表格
                multipleSelection: [],
                shujuTableData: [],
                tableData: [],
            }
        },

        //在模板编译进路由前调用created方法，触发接收函数
        created() {
            this.getParams();
        },
        methods: {
            //查询翻页
            query() {
                this.q.userName = this.cusmname,
                this.q.category = this.bigCategory,
                this.q.exfactoryDate = this.timechange,
                this.q.id = this.idmsg,
                ss.CompetitorsManager.selectPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.gettableels(rd.records);
                })
            },
            handleFilter() {
                this.jianSuo = true;
                this.query();
            },
            //检索趋势信息
            queryInfo() {
                this.lineChart();
                this.barChart();
                this.mapChart();
            },
            handleFilterInfo() {
                this.jianSuo = true;
                this.queryInfo();
            },
            //批量导表
            outExcel() {
                var canShu = {
                    userName: this.cusmname,
                    category: this.bigCategory,
                    exfactoryDate: this.timechange,
                    id: this.idmsg,
                };
                ss.CompetitorsManager.downloadExcel(canShu);
            },
            //点击查看详情
            // showels(item) {
            // },
            gettableels(vw) {
                this.shujuTableData = [];
                this.tableData = [];
                if (!this.jianSuo) {
                    this.cusmnameOptions = [];
                    this.bigCategoryOptions = [];
                }
                for (var ui in vw) {
                    var dd = 0;
                    var rr = 0;
                    if (!this.jianSuo) {
                        if (ui == 0) {
                            var cusmnameonee = {
                                value: '',
                                label: '--请选择--',
                            }
                            this.cusmnameOptions.push(cusmnameonee);
                            this.bigCategoryOptions.push(cusmnameonee);
                        }
                        var cusmnameone = {
                            value: vw[ui].userName,
                            label: vw[ui].userName,
                        }

                        for (var tt in this.cusmnameOptions) {
                            if (this.cusmnameOptions[tt].value == cusmnameone.value) {
                                dd = 1;
                            }
                        }
                        if (dd == 0) {
                            this.cusmnameOptions.push(cusmnameone);
                        }
                        var bigCategoryone = {
                            value: vw[ui].category,
                            label: vw[ui].category,
                        }
                        for (var hh in this.bigCategoryOptions) {
                            if (this.bigCategoryOptions[hh].value == bigCategoryone.value) {
                                rr = 1;
                            }
                        }
                        if (rr == 0) {
                            this.bigCategoryOptions.push(bigCategoryone);
                        }
                    }
                    var table = {
                        index: ui,//序号
                        pid: vw[ui].pid, //产品信息id
                        userName: vw[ui].userName, //客户名
                        channel: vw[ui].channel, //渠道
                        area: vw[ui].area, //区域
                        specification: vw[ui].specification,//型号
                        barCode: vw[ui].barCode,//条形码
                        exfactoryDate: vw[ui].exfactoryDate,//生产日期
                        category: vw[ui].category,//产品大类
                    };
                    this.shujuTableData.push(table);
                    this.tableData.push(table);
                }
            },
            //接收前页转发的竞争对手id
            getParams() {
                //拿到对手id
                this.idmsg = this.$router.history.current.query.id;
                ss.CompetitorsManager.findComs(this.idmsg).then(rd => {
                    this.duishou = rd.duishou;
                    this.query();
                })
            },
            //清空选项
            qingKong() {
                this.qushi.area = '';
                this.qushi.start = '';
                this.qushi.end = '';
                this.cusmname = '';
                this.bigCategory = '';
                this.timechange = '';
                this.jianSuo = false;
                this.getParams();
            },
            // //清空选项
            // quShiClear() {
            //     this.area = '';
            //     this.category = '';
            //     this.start = '';
            //     this.end = '';
            //     this.getParams();
            // },
            //修改等级的方法
            // lelchangetype() {
            //     console.log(this.leltype);
            //     var duixiang = {
            //         id: this.idmsg,
            //         concern: this.leltype,
            //     };
            //     ss.Competitors.updateById(duixiang);
            // },
            //
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            /*折线图*/
            lineChart() {
                var names = [];   //横坐标
                var valueH = [];//海尔纵坐标
                var valueC = []; //竞争者纵坐标
                var name = "";//竞争对手名
                this.q.id = this.idmsg,
                    this.q = this.qushi,
                ss.CompetitorsManager.getProGrowInfo(this.q).then(rd => {
                    if (rd) {
                        this.name = rd.companyName;
                        //给海尔产品信息赋值
                        if (rd.haierMap) {
                            for (var i = 0; i < rd.haierMap.haxis.length; i++) {
                                names.push(rd.haierMap.haxis[i]);
                                valueH.push(rd.haierMap.hseries[i]);
                            }
                            for (var j = 0; j < rd.compMap.caxis.length; j++) {
                                valueC.push(rd.compMap.cseries[j]);
                            }
                        }
                    }
                    lineChart.setOption({  //加载数据图表
                        xAxis: {
                            data: names,
                        },
                        series: [{
                            data: valueH,
                        }, {
                            name:name,
                            data: valueC,
                        }]
                    })
                })
                let lineChart = this.$echarts.init(document.getElementById('h_lineChart'));
                let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            show: true,
                            lineStyle: {
                                width: 1,
                                color: '#61a0f7'
                            }
                        }
                    },
                    color: ['#65a2f7', '#23b5b8'],
                    legend: {
                        show: true,
                        data: [{
                            name: '海尔产品',
                            icon: 'rect',
                        }, {
                            name: name,
                            icon: 'rect',
                        }],
                        itemWidth: 26,
                        itemHeight: 18,
                        itemGap: 70,
                        textStyle: {
                            color: '#494949',
                            fontSize: 18,
                            fontWeight: 'bold',
                            padding: [0, 0, 0, 10]
                        }
                    },
                    grid: {
                        left: 50,
                        top: 50,
                        right: 0,
                        bottom: 50,
                        borderWidth: 0
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            margin: 20,
                            color: '#b9b9b9',
                            fontFamily: 'Microsoft YaHei',
                            fontSize: 18
                        }
                    }],
                    yAxis: [{
                        name: '单位（台）',
                        type: 'value',
                        nameGap: 20,
                        nameTextStyle: {
                            color: '#a4a4a4',
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            margin: 0,
                            color: '#a4a4a4',
                            fontFamily: 'Microsoft YaHei',
                            fontSize: 13
                        }
                    }],
                    series: [{
                        name: "haier",
                        type: 'line',
                        symbol: 'roundRect',
                        symbolSize: 0,
                        showSymbol: false,
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(145,188,250,1)' // 0% 处的颜色
                                }, {
                                    offset: 0.5, color: 'rgba(145,188,250,0.5)' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(145,188,250,0)' // 100% 处的颜色
                                }],
                                globalCoord: false // 缺省为 false
                            },
                        },
                        smooth: true,
                        data: valueH,
                        lineStyle: {
                            color: '#61a0f7'
                        },
                    }, {
                        name:name,
                        type: 'line',
                        symbol: 'roundRect',
                        symbolSize: 0,
                        showSymbol: false,
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(178,229,230,1)' // 0% 处的颜色
                                }, {
                                    offset: 0.5, color: 'rgba(178,229,230,0.5)' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(178,229,230,0)' // 100% 处的颜色
                                }],
                                globalCoord: false // 缺省为 false
                            },
                        },
                        smooth: true,
                        data: valueC,
                        lineStyle: {
                            color: '#38b9c1'
                        },
                    },
                    ]
                };
                lineChart.setOption(option);
            },

            /*  柱状图*/
            barChart() {
                var name = "";//竞争对手名
                var names = [];   //横坐标
                var valueH = [];//海尔纵坐标
                var valueC = []; //竞争者纵坐标
                this.q.id = this.idmsg,
                    this.q = this.qushi,
                ss.CompetitorsManager.selectCompetitorsInfo(this.q).then(rd => {
                    if (rd) {
                        this.duishou.companyName == rd.companyName;
                        this.name = rd.companyName;

                        //给海尔产品信息赋值
                        if (rd.haierInfo) {
                            for (var i = 0; i < rd.haierInfo.haxis.length; i++) {
                                names.push(rd.haierInfo.haxis[i]);
                                valueH.push(rd.haierInfo.hseries[i]);
                                }
                            for (var j = 0; j < rd.competitorsInfo.caxis.length; j++) {
                                valueC.push(rd.competitorsInfo.cseries[j]);
                            }
                        }
                    }
                    barChart.setOption({  //加载数据图表
                        xAxis: {
                            data: names,
                        },
                        series: [{
                            data: valueH,
                        }, {
                            data: valueC,
                        }]
                    })
                })
                let barChart = this.$echarts.init(document.getElementById('h_barChart'));
                let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            show: true,
                            lineStyle: {
                                width: 1,
                                color: '#61a0f7'
                            }
                        }
                    },
                    color: ['#65a2f7', '#23b5b8'],
                    legend: {
                        show: false,
                        data: [{
                            name: '海尔产品',
                            // 强制设置图形为圆。
                            icon: 'rect',
                        }, {
                            name: name,
                            // 强制设置图形为圆。
                            icon: 'rect',
                        }],
                        itemWidth: 26,
                        itemHeight: 18,
                        itemGap: 70,
                        textStyle: {
                            color: '#494949',
                            fontSize: 18,
                            fontWeight: 'bold',
                            padding: [0, 0, 0, 10]
                        }
                    },
                    grid: {
                        left: 50,
                        top: 50,
                        right: 0,
                        bottom: 50,
                        borderWidth: 0
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            margin: 20,
                            color: '#b9b9b9',
                            fontFamily: 'Microsoft YaHei',
                            fontSize: 18
                        }
                    }],
                    yAxis: [{
                        name: '单位（台）',
                        type: 'value',
                        nameGap: 20,
                        nameTextStyle: {
                            color: '#a4a4a4',
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            margin: 0,
                            color: '#a4a4a4',
                            fontFamily: 'Microsoft YaHei',
                            fontSize: 13
                        }
                    }],
                    series: [{
                        name: '海尔产品',
                        type: 'bar',
                        barWidth: 6,
                        barGap: '100%',
                        itemStyle: {
                            barBorderRadius: 6
                        },
                        data:valueH,
                    }, {
                        name: name,
                        type: 'bar',
                        barWidth: 6,
                        barGap: '100%',
                        itemStyle: {
                            barBorderRadius: 6
                        },
                        data: valueC,
                    },
                    ]
                };
                barChart.setOption(option);
            },
            /*中国地图*/
            mapChart() {
                this.q.id = this.idmsg,
                this.q = this.qushi,
                ss.CompetitorsManager.getCompAreaInfo(this.q).then(rd => {
                    this.fenBuNum = '0';
                    var data = [];
                    //请求成功时执行该函数内容，result即为服务器返回的map对象
                    if (rd) {
                        this.fenBuNum = rd.amount;
                        for (var i = 0; i < rd.areaList.caxis.length; i++) {
                            data.push({
                                name: rd.areaList.caxis[i],
                                value: rd.areaList.cseries[i]
                            });
                        }
                    }
                    mapChart.setOption({  //加载数据图表
                        series: [{
                            data: data,
                        }]
                    })
                })
                let mapChart = this.$echarts.init(document.getElementById('h_mapChart'));
                /*let data =  [
                    // {name: '海门', value: 9},
                    // {name: '鄂尔多斯', value: 12},
                    // {name: '招远', value: 12},
                    // {name: '青岛', value: 320},
                    // {name: '乳山', value: 18},
                    // {name: '金昌', value: 19},
                    // {name: '泉州', value: 21},
                    // {name: '莱西', value: 21},
                    // {name: '日照', value: 21},
                    // {name: '胶南', value: 22},
                    // {name: '南通', value: 23},
                    // {name: '拉萨', value: 24},
                    // {name: '云浮', value: 24},
                    // {name: '梅州', value: 25},
                    // {name: '文登', value: 25},
                    // {name: '上海', value: 225},
                    // {name: '攀枝花', value: 25},
                    // {name: '威海', value: 25},
                    // {name: '承德', value: 25},
                    // {name: '厦门', value: 26},
                    // {name: '汕尾', value: 26},
                    // {name: '潮州', value: 26},
                    // {name: '丹东', value: 27},
                    // {name: '太仓', value: 27},
                    // {name: '曲靖', value: 27},
                    // {name: '烟台', value: 28},
                    // {name: '福州', value: 29},
                    // {name: '瓦房店', value: 30},
                    // {name: '即墨', value: 30},
                    // {name: '抚顺', value: 31},
                    // {name: '玉溪', value: 31},
                    // {name: '张家口', value: 31},
                    // {name: '阳泉', value: 31},
                    // {name: '莱州', value: 32},
                    // {name: '湖州', value: 32},
                    // {name: '汕头', value: 32},
                    // {name: '昆山', value: 33},
                    // {name: '宁波', value: 33},
                    // {name: '湛江', value: 33},
                    // {name: '揭阳', value: 34},
                    // {name: '荣成', value: 34},
                    // {name: '连云港', value: 35},
                    // {name: '葫芦岛', value: 35},
                    // {name: '常熟', value: 36},
                    // {name: '东莞', value: 36},
                    // {name: '河源', value: 36},
                    // {name: '淮安', value: 36},
                    // {name: '泰州', value: 36},
                    // {name: '南宁', value: 37},
                    // {name: '营口', value: 37},
                    // {name: '惠州', value: 37},
                    // {name: '江阴', value: 37},
                    // {name: '韶关', value: 38},
                    // {name: '嘉峪关', value: 38},
                    // {name: '广州', value: 238},
                    // {name: '延安', value: 38},
                    // {name: '盘锦', value: 40},
                    // {name: '长治', value: 41},
                    // {name: '深圳', value: 241},
                    // {name: '珠海', value: 42},
                    // {name: '宿迁', value: 43},
                    // {name: '咸阳', value: 43},
                    // {name: '铜川', value: 44},
                    // {name: '佛山', value: 44},
                    // {name: '海口', value: 44},
                    // {name: '江门', value: 45},
                    // {name: '肇庆', value: 46},
                    // {name: '大连', value: 47},
                    // {name: '临汾', value: 47},
                    // {name: '吴江', value: 47},
                    // {name: '石嘴山', value: 49},
                    // {name: '沈阳', value: 50},
                    // {name: '苏州', value: 50},
                    // {name: '茂名', value: 50},
                    // {name: '嘉兴', value: 51},
                    // {name: '长春', value: 51},
                    // {name: '胶州', value: 52},
                    // {name: '银川', value: 52},
                    // {name: '张家港', value: 52},
                    // {name: '三门峡', value: 53},
                    // {name: '锦州', value: 54},
                    // {name: '南昌', value: 54},
                    // {name: '柳州', value: 54},
                    // {name: '三亚', value: 54},
                    // {name: '自贡', value: 56},
                    // {name: '吉林', value: 56},
                    // {name: '阳江', value: 57},
                    // {name: '泸州', value: 57},
                    // {name: '西宁', value: 57},
                    // {name: '宜宾', value: 58},
                    // {name: '成都', value: 218},
                    // {name: '镇江', value: 59},
                    // {name: '桂林', value: 59},
                    // {name: '宜兴', value: 59},
                    // {name: '北海', value: 60},
                    // {name: '西安', value: 61},
                    // {name: '金坛', value: 62},
                    // {name: '东营', value: 62},
                    // {name: '牡丹江', value: 63},
                    // {name: '遵义', value: 63},
                    // {name: '绍兴', value: 63},
                    // {name: '扬州', value: 64},
                    // {name: '常州', value: 64},
                    // {name: '重庆', value: 66},
                    // {name: '南京', value: 67},
                    // {name: '滨州', value: 70},
                    // {name: '贵阳', value: 71},
                    // {name: '无锡', value: 71},
                    // {name: '本溪', value: 71},
                    // {name: '克拉玛依', value: 72},
                    // {name: '渭南', value: 72},
                    // {name: '马鞍山', value: 72},
                    // {name: '宝鸡', value: 72},
                    // {name: '焦作', value: 75},
                    // {name: '句容', value: 75},
                    // {name: '北京', value: 269},
                    // {name: '徐州', value: 79},
                    // {name: '衡水', value: 80},
                    // {name: '绵阳', value: 80},
                    // {name: '乌鲁木齐', value: 84},
                    // {name: '枣庄', value: 84},
                    // {name: '杭州', value: 84},
                    // {name: '淄博', value: 85},
                    // {name: '鞍山', value: 86},
                    // {name: '溧阳', value: 86},
                    // {name: '库尔勒', value: 86},
                    // {name: '安阳', value: 90},
                    // {name: '开封', value: 90},
                    // {name: '济南', value: 92},
                    // {name: '德阳', value: 93},
                    // {name: '九江', value: 96},
                    // {name: '邯郸', value: 98},
                    // {name: '临安', value: 99},
                    // {name: '兰州', value: 99},
                    // {name: '沧州', value: 100},
                    // {name: '临沂', value: 103},
                    // {name: '南充', value: 104},
                    // {name: '天津', value: 105},
                    // {name: '富阳', value: 106},
                    // {name: '泰安', value: 112},
                    // {name: '郑州', value: 113},
                    // {name: '哈尔滨', value: 114},
                    // {name: '聊城', value: 116},
                    // {name: '芜湖', value: 117},
                    // {name: '唐山', value: 119},
                    // {name: '平顶山', value: 119},
                    // {name: '邢台', value: 119},
                    // {name: '济宁', value: 120},
                    // {name: '荆州', value: 127},
                    // {name: '宜昌', value: 130},
                    // {name: '洛阳', value: 134},
                    // {name: '秦皇岛', value: 136},
                    // {name: '株洲', value: 143},
                    // {name: '石家庄', value: 147},
                    // {name: '莱芜', value: 148},
                    // {name: '金华', value: 107},
                    // {name: '长沙', value: 175},
                    // {name: '衢州', value: 177},
                    // {name: '合肥', value: 100},
                    // {name: '武汉', value: 90},
                ];*/

             /*   let geoCoordMap = {
                    // '海门': [121.15, 31.89],
                    // '鄂尔多斯': [109.781327, 39.608266],
                    // '招远': [120.38, 37.35],
                    // '舟山': [122.207216, 29.985295],
                    // '齐齐哈尔': [123.97, 47.33],
                    // '盐城': [120.13, 33.38],
                    // '赤峰': [118.87, 42.28],
                    // '青岛': [120.33, 36.07],
                    // '乳山': [121.52, 36.89],
                    // '金昌': [102.188043, 38.520089],
                    // '泉州': [118.58, 24.93],
                    // '莱西': [120.53, 36.86],
                    // '日照': [119.46, 35.42],
                    // '胶南': [119.97, 35.88],
                    // '南通': [121.05, 32.08],
                    // '拉萨': [91.11, 29.97],
                    // '云浮': [112.02, 22.93],
                    // '梅州': [116.1, 24.55],
                    // '文登': [122.05, 37.2],
                    // '上海': [121.48, 31.22],
                    // '攀枝花': [101.718637, 26.582347],
                    // '威海': [122.1, 37.5],
                    // '承德': [117.93, 40.97],
                    // '厦门': [118.1, 24.46],
                    // '汕尾': [115.375279, 22.786211],
                    // '潮州': [116.63, 23.68],
                    // '丹东': [124.37, 40.13],
                    // '太仓': [121.1, 31.45],
                    // '曲靖': [103.79, 25.51],
                    // '烟台': [121.39, 37.52],
                    // '福州': [119.3, 26.08],
                    // '瓦房店': [121.979603, 39.627114],
                    // '即墨': [120.45, 36.38],
                    // '抚顺': [123.97, 41.97],
                    // '玉溪': [102.52, 24.35],
                    // '张家口': [114.87, 40.82],
                    // '阳泉': [113.57, 37.85],
                    // '莱州': [119.942327, 37.177017],
                    // '湖州': [120.1, 30.86],
                    // '汕头': [116.69, 23.39],
                    // '昆山': [120.95, 31.39],
                    // '宁波': [121.56, 29.86],
                    // '湛江': [110.359377, 21.270708],
                    // '揭阳': [116.35, 23.55],
                    // '荣成': [122.41, 37.16],
                    // '连云港': [119.16, 34.59],
                    // '葫芦岛': [120.836932, 40.711052],
                    // '常熟': [120.74, 31.64],
                    // '东莞': [113.75, 23.04],
                    // '河源': [114.68, 23.73],
                    // '淮安': [119.15, 33.5],
                    // '泰州': [119.9, 32.49],
                    // '南宁': [108.33, 22.84],
                    // '营口': [122.18, 40.65],
                    // '惠州': [114.4, 23.09],
                    // '江阴': [120.26, 31.91],
                    // '蓬莱': [120.75, 37.8],
                    // '韶关': [113.62, 24.84],
                    // '嘉峪关': [98.289152, 39.77313],
                    // '广州': [113.23, 23.16],
                    // '延安': [109.47, 36.6],
                    // '太原': [112.53, 37.87],
                    // '清远': [113.01, 23.7],
                    // '中山': [113.38, 22.52],
                    // '昆明': [102.73, 25.04],
                    // '寿光': [118.73, 36.86],
                    // '盘锦': [122.070714, 41.119997],
                    // '长治': [113.08, 36.18],
                    // '深圳': [114.07, 22.62],
                    // '珠海': [113.52, 22.3],
                    // '宿迁': [118.3, 33.96],
                    // '咸阳': [108.72, 34.36],
                    // '铜川': [109.11, 35.09],
                    // '平度': [119.97, 36.77],
                    // '佛山': [113.11, 23.05],
                    // '海口': [110.35, 20.02],
                    // '江门': [113.06, 22.61],
                    // '章丘': [117.53, 36.72],
                    // '肇庆': [112.44, 23.05],
                    // '大连': [121.62, 38.92],
                    // '临汾': [111.5, 36.08],
                    // '吴江': [120.63, 31.16],
                    // '石嘴山': [106.39, 39.04],
                    // '沈阳': [123.38, 41.8],
                    // '苏州': [120.62, 31.32],
                    // '茂名': [110.88, 21.68],
                    // '嘉兴': [120.76, 30.77],
                    // '长春': [125.35, 43.88],
                    // '胶州': [120.03336, 36.264622],
                    // '银川': [106.27, 38.47],
                    // '张家港': [120.555821, 31.875428],
                    // '三门峡': [111.19, 34.76],
                    // '锦州': [121.15, 41.13],
                    // '南昌': [115.89, 28.68],
                    // '柳州': [109.4, 24.33],
                    // '三亚': [109.511909, 18.252847],
                    // '自贡': [104.778442, 29.33903],
                    // '吉林': [126.57, 43.87],
                    // '阳江': [111.95, 21.85],
                    // '泸州': [105.39, 28.91],
                    // '西宁': [101.74, 36.56],
                    // '宜宾': [104.56, 29.77],
                    // '呼和浩特': [111.65, 40.82],
                    // '成都': [104.06, 30.67],
                    // '大同': [113.3, 40.12],
                    // '镇江': [119.44, 32.2],
                    // '桂林': [110.28, 25.29],
                    // '张家界': [110.479191, 29.117096],
                    // '宜兴': [119.82, 31.36],
                    // '北海': [109.12, 21.49],
                    // '西安': [108.95, 34.27],
                    // '金坛': [119.56, 31.74],
                    // '东营': [118.49, 37.46],
                    // '牡丹江': [129.58, 44.6],
                    // '遵义': [106.9, 27.7],
                    // '绍兴': [120.58, 30.01],
                    // '扬州': [119.42, 32.39],
                    // '常州': [119.95, 31.79],
                    // '潍坊': [119.1, 36.62],
                    // '重庆': [106.54, 29.59],
                    // '台州': [121.420757, 28.656386],
                    // '南京': [118.78, 32.04],
                    // '滨州': [118.03, 37.36],
                    // '贵阳': [106.71, 26.57],
                    // '无锡': [120.29, 31.59],
                    // '本溪': [123.73, 41.3],
                    // '克拉玛依': [84.77, 45.59],
                    // '渭南': [109.5, 34.52],
                    // '马鞍山': [118.48, 31.56],
                    // '宝鸡': [107.15, 34.38],
                    // '焦作': [113.21, 35.24],
                    // '句容': [119.16, 31.95],
                    // '北京': [116.46, 39.92],
                    // '徐州': [117.2, 34.26],
                    // '衡水': [115.72, 37.72],
                    // '包头': [110, 40.58],
                    // '绵阳': [104.73, 31.48],
                    // '乌鲁木齐': [87.68, 43.77],
                    // '枣庄': [117.57, 34.86],
                    // '杭州': [120.19, 30.26],
                    // '淄博': [118.05, 36.78],
                    // '鞍山': [122.85, 41.12],
                    // '溧阳': [119.48, 31.43],
                    // '库尔勒': [86.06, 41.68],
                    // '安阳': [114.35, 36.1],
                    // '开封': [114.35, 34.79],
                    // '济南': [117, 36.65],
                    // '德阳': [104.37, 31.13],
                    // '温州': [120.65, 28.01],
                    // '九江': [115.97, 29.71],
                    // '邯郸': [114.47, 36.6],
                    // '临安': [119.72, 30.23],
                    // '兰州': [103.73, 36.03],
                    // '沧州': [116.83, 38.33],
                    // '临沂': [118.35, 35.05],
                    // '南充': [106.110698, 30.837793],
                    // '天津': [117.2, 39.13],
                    // '富阳': [119.95, 30.07],
                    // '泰安': [117.13, 36.18],
                    // '诸暨': [120.23, 29.71],
                    // '郑州': [113.65, 34.76],
                    // '哈尔滨': [126.63, 45.75],
                    // '聊城': [115.97, 36.45],
                    // '芜湖': [118.38, 31.33],
                    // '唐山': [118.02, 39.63],
                    // '平顶山': [113.29, 33.75],
                    // '邢台': [114.48, 37.05],
                    // '德州': [116.29, 37.45],
                    // '济宁': [116.59, 35.38],
                    // '荆州': [112.239741, 30.335165],
                    // '宜昌': [111.3, 30.7],
                    // '义乌': [120.06, 29.32],
                    // '丽水': [119.92, 28.45],
                    // '洛阳': [112.44, 34.7],
                    // '秦皇岛': [119.57, 39.95],
                    // '株洲': [113.16, 27.83],
                    // '石家庄': [114.48, 38.03],
                    // '莱芜': [117.67, 36.19],
                    // '常德': [111.69, 29.05],
                    // '保定': [115.48, 38.85],
                    // '湘潭': [112.91, 27.87],
                    // '金华': [119.64, 29.12],
                    // '岳阳': [113.09, 29.37],
                    // '长沙': [113, 28.21],
                    // '衢州': [118.88, 28.97],
                    // '廊坊': [116.7, 39.53],
                    // '菏泽': [115.480656, 35.23375],
                    // '合肥': [117.27, 31.86],
                    // '武汉': [114.31, 30.52],
                    // '大庆': [125.03, 46.58]
                };

                let convertData = function (data) {
                    let res = [];
                    for (let i = 0; i < data.length; i++) {
                        let geoCoord = geoCoordMap[data[i].name];
                        if (geoCoord) {
                            res.push({
                                name: data[i].name,
                                value: geoCoord.concat(data[i].value)
                            });
                        }
                    }
                    return res;
                };*/
                let option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    grid: {
                        left: 0,
                        top: 0,
                        bottom: 0,
                        right: 0
                    },
                    visualMap: {
                        min: 0,
                        max: 1200,
                        seriesIndex: [0],
                        text: ['低', '高'],
                        inRange: {
                            color: ['#0e75e9', '#5ca8ff', '#95c6ff', '#b2d6ff'],
                        },
                        textStyle: {
                            color: '#616467'
                        },
                        align: 'left',
                        orient: 'horizontal',
                        right: 0,
                        padding: 0,
                        bottom: 80,
                    },
                    color: ['#0e75e9', '#5ca8ff', '#95c6ff', '#b2d6ff'],
                    // geo: {
                    //     map: 'china',
                    //     roam: true,
                    //     label: {
                    //         emphasis: {
                    //             show: false
                    //         }
                    //     },
                    //     left: 30,
                    //     itemStyle: {
                    //         normal: {
                    //             areaColor: '#b2d6ff',
                    //             borderColor: '#fff'
                    //         },
                    //         emphasis: {
                    //             areaColor: '#0e75e9'
                    //         }
                    //     }
                    // },
                    series: [
                        {
                            name: '销售点',
                            type: 'map',
                            mapType: 'china',
                            label: {
                                normal: {
                                    show: false
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                borderColor: '#fff',
                                borderWidth: 1,
                            },
                            left: 30,
                            data:[],
                            // data: [
                            //     // {name: '北京', value: Math.round(Math.random() * 1000)},
                            //     // {name: '天津', value: Math.round(Math.random() * 1000)},
                            //     // {name: '上海', value: Math.round(Math.random() * 1000)},
                            //     // {name: '重庆', value: Math.round(Math.random() * 1000)},
                            //     // {name: '河北', value: Math.round(Math.random() * 1000)},
                            //     // {name: '河南', value: Math.round(Math.random() * 1000)},
                            //     // {name: '云南', value: Math.round(Math.random() * 1000)},
                            //     // {name: '辽宁', value: Math.round(Math.random() * 1000)},
                            //     // {name: '黑龙江', value: Math.round(Math.random() * 1000)},
                            //     // {name: '湖南', value: Math.round(Math.random() * 1000)},
                            //     // {name: '安徽', value: Math.round(Math.random() * 1000)},
                            //     // {name: '山东', value: Math.round(Math.random() * 1000)},
                            //     // {name: '新疆', value: Math.round(Math.random() * 1000)},
                            //     // {name: '江苏', value: Math.round(Math.random() * 1000)},
                            //     // {name: '浙江', value: Math.round(Math.random() * 1000)},
                            //     // {name: '江西', value: Math.round(Math.random() * 1000)},
                            //     // {name: '湖北', value: Math.round(Math.random() * 1000)},
                            //     // {name: '广西', value: Math.round(Math.random() * 1000)},
                            //     // {name: '甘肃', value: Math.round(Math.random() * 1000)},
                            //     // {name: '山西', value: Math.round(Math.random() * 1000)},
                            //     // {name: '内蒙古', value: Math.round(Math.random() * 1000)},
                            //     // {name: '陕西', value: Math.round(Math.random() * 1000)},
                            //     // {name: '吉林', value: Math.round(Math.random() * 1000)},
                            //     // {name: '福建', value: Math.round(Math.random() * 1000)},
                            //     // {name: '贵州', value: Math.round(Math.random() * 1000)},
                            //     // {name: '广东', value: Math.round(Math.random() * 1000)},
                            //     // {name: '青海', value: Math.round(Math.random() * 1000)},
                            //     // {name: '西藏', value: Math.round(Math.random() * 1000)},
                            //     // {name: '四川', value: Math.round(Math.random() * 1000)},
                            //     // {name: '宁夏', value: Math.round(Math.random() * 1000)},
                            //     // {name: '海南', value: Math.round(Math.random() * 1000)},
                            //     // {name: '台湾', value: Math.round(Math.random() * 1000)},
                            //     // {name: '香港', value: Math.round(Math.random() * 1000)},
                            //     // {name: '澳门', value: Math.round(Math.random() * 1000)}
                            // ]
                        },
               /*         {
                            name: '销售分布点',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            data: data,
                            symbolSize: 6,
                            label: {
                                normal: {
                                    formatter: '{b}',
                                    position: 'left',
                                    show: false
                                },
                                emphasis: {
                                    show: true
                                }
                            },
                            itemStyle: {
                                borderColor: '#fff',
                                borderWidth: 1,
                                normal: {
                                    color: '#ffdb6c'
                                }
                            }
                        },
*/
                    ]
                }
                mapChart.setOption(option);
            },
        },
        mounted() {
            this.lineChart();
            this.barChart();
            this.mapChart();
        },
    }
</script>
